import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
interface FloatingCTAProps {
  triggerId: string;
}
export function FloatingCTA({
  triggerId
}: FloatingCTAProps) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const trigger = document.getElementById(triggerId);
    if (!trigger) return;
    const observer = new IntersectionObserver(([entry]) => {
      const passed = entry.boundingClientRect.top < 0;
      setVisible(!entry.isIntersecting && passed);
    }, {
      threshold: 0
    });
    observer.observe(trigger);
    return () => observer.disconnect();
  }, [triggerId]);
  return <AnimatePresence data-id="element-32" data-mp="2atgxme8bxy3c">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 24
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 24
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3" data-id="element-33" data-mp="38b8nm837wooy">
          <div className="mx-auto max-w-md" data-id="element-34" data-mp="333azb9sqh0q0">
            <a href={CHECKOUT_URL} className="mp-shake flex w-full items-center justify-center gap-2 rounded-xl bg-gold-500 px-4 py-4 text-center font-display text-sm sm:text-base uppercase tracking-wide text-navy-950 shadow-[0_12px_34px_-8px_rgba(0,0,0,0.9)] transition-colors duration-200 ease-out hover:bg-gold-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-300" data-id="element-35" data-mp="33318xl3s0rjs">
              Get the deck — $27 today
              <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-36" data-mp="26f4pm8gyfi4v" />
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}